import { UIText2, UIText3 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IDiscountProps {
  originalPrice: string;
  discountPercent: string;
  isCompact?: boolean;
}

export const Discount = ({ originalPrice, discountPercent, isCompact = false }: IDiscountProps) => {
  // Компактное desktop-превью (<1366) мельче основного
  const Text = isCompact ? UIText3 : UIText2;

  return (
    <div className={cn(styles['discount'], isCompact && styles['discount--compact'])} data-testid="discount">
      <span className={styles['discount-percent']}>
        <Text color="text-inverted-default" data-testid="discount-percent">
          {discountPercent}
        </Text>
      </span>
      <span className={styles['original-price']}>
        <Text color="text-secondary-default" data-testid="discount-original-price">
          {originalPrice}
        </Text>
      </span>
    </div>
  );
};
